module.exports = __webpack_public_path__ + "img/designs-479.9ec8901.png";